import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import Caption from '../Caption';
import Label from '../Label';
import uuid from '../../utils/methods/uuid';
import styles from './Checkbox.module.css';

const bindClasses = classNameBind.bind(styles);

export default class Checkbox extends React.Component {
  static defaultProps = {
    id: uuid(),
    label: null,
    caption: null,
    value: '',
    disabled: false,
    onChange: () => {},
    field: null,
    error: null,
    dataId: 'Checkbox',
    checkedMixed: false,
  }

  handleChange = () => {
    const {
      onChange,
      disabled,
      checked,
      value,
      name,
    } = this.props;

    if (!disabled) {
      if (typeof value !== 'boolean') {
        onChange({
          target: {
            name,
            checked: !checked,
            value,
          },
        });
      } else {
        onChange({
          target: {
            name,
            value: !value,
          },
        });
      }
    }
  }

  render() {
    const {
      id,
      label,
      caption,
      disabled,
      checked,
      field,
      name,
      error,
      dataId,
      checkedMixed,
    } = this.props;
    const fieldInput = field ? field.input : {};
    const input = {
      ...fieldInput,
      checked,
      disabled,
      id,
      name,
      onChange: this.handleChange,
    };

    return (
      <div className={bindClasses('Checkbox', { invalid: !error })} data-ppuc-id={dataId}>
        <label className={bindClasses('widget')} data-ppuc-id={`${dataId}.checkmark`} htmlFor={id}>
          <Icon
            name={checkedMixed ? 'line' : 'checkmark'}
            color="white"
            className={bindClasses('icon', {
              disabled,
              checked,
              withLabel: label,
              invalid: error,
            })}
          />
          <input type="checkbox" {...input} data-ppuc-id={`${dataId}.input`} id={id} />
        </label>
        <div>
          {label ? <Label htmlFor={id} disabled={disabled} dataId={`${dataId}.label`}>{label}</Label> : null }
          {caption ? <Caption cutText={false} subdued dataId={`${dataId}.caption`}>{caption}</Caption> : null }
        </div>
      </div>
    );
  }
}
